import React from "react";

const NotificationListener = () => {

  return null;
};

export default NotificationListener;